export default "__VITE_ASSET__HalcAtB4__"